<template>
  <CommonPage>
<!--    <div class="common-img" slot="img-icon"></div>-->
    <i class="el-icon-s-custom" slot="logo"></i>
    <div class="login-content">
      <h3 class="box-title">认证计费总平台</h3>
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="username">
          <el-input prefix-icon="el-icon-mobile-phone" placeholder="手机号" clearable maxLength="11"
                    v-model.trim="form.username" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-col :span="15">
            <el-input v-model.trim="form.password" autocomplete="off" clearable maxLength="18" prefix-icon="el-icon-edit-outline" placeholder="验证码"></el-input>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-button type="primary" class="code-btn" @click="getCode" :disabled="disabled">{{btnTxt}}</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="login-btn" @click="login">确定</el-button>
    </div>
  </CommonPage>
</template>

<script>
  import {inputEmpty} from "@utils/validate"
  import CommonPage from "@view/components/CommonPage"
  export default {
    name: "index",
    components: {CommonPage},
    data() {
      return {
        form: {
          username: process.env.NODE_ENV === "production" ? "" : "13438323907",
          password: process.env.NODE_ENV === "production" ? "" : "wayos028",
        },
        rules: {
          username: [inputEmpty("手机号")],
          password: [inputEmpty("验证码")],
        },
        // 验证码
        disabled: false,
        time: 0,
        btnTxt: "获取验证码",
        timer: null,
      }
    },
    methods: {
      //获取手机验证码
      async getCode() {
        let mobile = this.form.username;
        this.$refs["form"].validateField("username", async error => {
          if (!error) {
            let res = await this.$Http.sendSms({type: 'admin', mobile});
            if (res) {
              this.form.password = res.data || "";
              this.msgSuccess("发送成功");
              this.time = 60;
              this.disabled = true;
              this.timerCount();
            }
          }
        });
      },
      timerCount() {
        if (this.time > 0) {
          this.time--;
          this.btnTxt = "请稍等(" + this.time + "s)";
          this.timer = setTimeout(this.timerCount, 1000);
        } else {
          this.time = 0;
          this.btnTxt = "获取验证码";
          this.disabled = false;
        }
      },
      // 登陆
      login() {
        this.$refs['form'].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            nv.password = encodeURIComponent(this.form.password);
            let res = await this.$Http.login(nv);
            if (res?.data) {
              this.$store.commit("setLoginInfo", {
                uid: res.data.uid,
                token: res.data.utoken,
                nickName: res.data.name,
              });
              this.msgSuccess("登录成功");
              this.$router.replace("/index").catch(() => {});
            }
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .login-content {
    .box-title {
      font-size: 24px;
      text-align: center;
      line-height: 46px;
      color: $home-color;
      font-weight: normal;
      margin-bottom: 15px;
    }
    .image-code-box {
      box-sizing: border-box;
      height: 40px;
      cursor: pointer;
      border: 1px solid $input-border-color;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .code-btn {
      width: 100%;
      padding: 0;
      height: 40px;
      font-size: 13px;
    }
    .login-btn {
      margin: 15px 0 20px;
      width: 100%;
    }
  }
</style>
